import { render, staticRenderFns } from "./MesesAnos.vue?vue&type=template&id=bef60406&scoped=true&"
import script from "./MesesAnos.vue?vue&type=script&lang=js&"
export * from "./MesesAnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef60406",
  null
  
)

export default component.exports